import img1 from "./srdov-1.jpg";
import img2 from "./srdov-2.jpg";
import img3 from "./srdov-3.jpg";
import img4 from "./srdov-4.jpg";
import img5 from "./srdov-5.jpg";
import img6 from "./srdov-6.jpg";
import img7 from "./srdov-7.jpg";
import img8 from "./srdov-8.jpg";
import img9 from "./srdov-9.jpg";
import img10 from "./srdov-10.jpg";
import img11 from "./srdov-11.jpg";
import img12 from "./srdov-12.jpg";
import img13 from "./srdov-13.jpg";
import img14 from "./srdov-14.jpg";
import img15 from "./srdov-15.jpg";
import img16 from "./srdov-16.jpg";
import img17 from "./srdov-17.jpg";
import img18 from "./srdov-18.jpg";
import img19 from "./srdov-19.jpg";
import img20 from "./srdov-20.jpg";
import img21 from "./srdov-21.jpg";
import img22 from "./srdov-22.jpg";
import img23 from "./srdov-23.jpg";
import img24 from "./srdov-24.jpg";
import img25 from "./srdov-25.jpg";
import img26 from "./srdov-26.jpg";
import img27 from "./srdov-27.jpg";
import img28 from "./srdov-28.jpg";
import img29 from "./srdov-29.jpg";
import img30 from "./srdov-30.jpg";
import img31 from "./srdov-31.jpg";
import img32 from "./srdov-32.jpg";
import img33 from "./srdov-33.jpg";
import img34 from "./srdov-34.jpg";
import img35 from "./srdov-35.jpg";
import img36 from "./srdov-36.jpg";
import img37 from "./srdov-37.jpg";
import img38 from "./srdov-38.jpg";
import img39 from "./srdov-39.jpg";

import fp1f3d from "./fp-1f-3d.jpg";
import fp1f2d from "./fp-1f-2d.jpg";
import fp2f3d from "./fp-2f-3d.jpg";
import fp2f2d from "./fp-2f-2d.jpg";
import fp3f3d from "./fp-3f-3d.jpg";
import fp3f2d from "./fp-3f-2d.jpg";

export const srdovImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39,
];

export const srdovFloorPlans = [
  { image: fp1f3d, label: "1. patro – 3D" },
  { image: fp1f2d, label: "1. patro – 2D" },
  { image: fp2f3d, label: "2. patro – 3D" },
  { image: fp2f2d, label: "2. patro – 2D" },
  { image: fp3f3d, label: "3. patro – 3D" },
  { image: fp3f2d, label: "3. patro – 2D" },
];
